import { Modal, Checkbox, Space, Tag, Typography, Divider, Button } from "antd";
import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { HolderOutlined } from "@ant-design/icons";
const disabledKeys = ["course_id", "name", "actions"];

const ListingColumnModal = ({
  isModalOpen,
  setIsModalOpen,
  columnOptions,
  visibleColumns,
  handleCheckboxChange,
  onSubmit,
  resetColumns,
}) => {
  const [checkedColumns, setCheckedColumns] = useState([]);

  useEffect(() => {
    setCheckedColumns(visibleColumns);
  }, [visibleColumns]);
  const handleDragEnd = (result) => {
    if (!result.destination) return;

    // Separate out 'actions' and other fixed columns
    const fixedWithoutActions = checkedColumns.filter(
      (key) => disabledKeys.includes(key) && key !== "actions"
    );
    const actionsColumn = checkedColumns.find((key) => key === "actions");
    const reorderable = checkedColumns.filter(
      (key) => !disabledKeys.includes(key)
    );

    // Reorder the reorderable list
    const [moved] = reorderable.splice(result.source.index, 1);
    reorderable.splice(result.destination.index, 0, moved);

    // Rebuild final list: fixed first, then reordered, then actions at the end
    const newOrder = [
      ...fixedWithoutActions,
      ...reorderable,
      ...(actionsColumn ? [actionsColumn] : []),
    ];

    setCheckedColumns(newOrder);

    onSubmit(newOrder);
  };

  return (
    <Modal
      title="Select & Reorder Columns"
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            key="reset"
            type="default"
            onClick={() => {
              resetColumns();
              setIsModalOpen(false);
            }}
          >
            Reset
          </Button>

          <Button
            key="submit"
            type="primary"
            onClick={() => {
              onSubmit(visibleColumns);
              setIsModalOpen(false);
            }}
            disabled={visibleColumns.length === 0}
            style={{ marginLeft: 8 }}
          >
            Save
          </Button>
        </div>
      }
      width={500}
    >
      <Divider style={{ marginTop: 5, marginBottom: 5 }} />
      <Space direction="vertical" style={{ width: "100%" }}>
        <Typography.Text
          className="my-form-lables"
          style={{ paddingInline: 5, margin: 0 }}
        >
          Visible Columns (Drag to Reorder)
        </Typography.Text>
        {checkedColumns
          .filter((key) => disabledKeys.includes(key))
          .map((key) => {
            const option = columnOptions.find((o) => o.value === key);
            return (
              <div
                key={key}
                style={{ display: "flex", alignItems: "center", padding: 8 }}
              >
                <Checkbox checked disabled value={key} style={{ flex: 1 }}>
                  {option?.label}
                </Checkbox>
                <Tag color="default" style={{ marginLeft: 8 }}>
                  Fixed
                </Tag>
              </div>
            );
          })}
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="checked-columns">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {checkedColumns
                  .filter((key) => !disabledKeys.includes(key))
                  .map((key, index) => {
                    const option = columnOptions.find((o) => o.value === key);
                    if (!option) return null;

                    return (
                      <Draggable
                        key={option.value}
                        draggableId={option.value}
                        index={index}
                      >
                        {(dragProvided, snapshot) => (
                          <div
                            ref={dragProvided.innerRef}
                            {...dragProvided.draggableProps}
                            {...dragProvided.dragHandleProps}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: 8,
                              marginBottom: 6,
                              background: snapshot.isDragging
                                ? "#e6f7ff"
                                : "#fafafa",
                              border: "1px solid #d9d9d9",
                              borderRadius: 4,
                              cursor: "grab",
                              ...dragProvided.draggableProps.style,
                            }}
                          >
                            {/* Draggable Icon */}
                            <HolderOutlined
                              style={{
                                marginRight: 8,
                                cursor: "grab",
                                color: "black",
                              }}
                            />

                            <Checkbox
                              checked
                              onChange={handleCheckboxChange}
                              value={option.value}
                              style={{ flex: 1 }}
                            >
                              {option.label}
                            </Checkbox>
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {columnOptions.some((col) => !checkedColumns.includes(col.value)) && (
          <>
            <Divider style={{ marginTop: 5, marginBottom: 5 }} />
            <Typography.Text
              className="my-form-lables"
              style={{ paddingInline: 5 }}
            >
              Hidden Columns
            </Typography.Text>
            {columnOptions
              .filter((col) => !checkedColumns.includes(col.value))
              .map((option) => (
                <div
                  key={option.value}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: 6,
                  }}
                >
                  <Checkbox
                    checked={false}
                    onChange={handleCheckboxChange}
                    value={option.value}
                    disabled={disabledKeys.includes(option.value)}
                    style={{ flex: 1 }}
                  >
                    {option.label}
                  </Checkbox>
                </div>
              ))}
          </>
        )}
      </Space>
    </Modal>
  );
};

export default ListingColumnModal;
